import { useEffect, useRef, useState } from 'react'
import './web-test-funding.css'

const STEPS = [
  { id: '01', title: 'Create Live Account', note: null },
  { id: '02', title: 'Complete Verification', note: 'if required' },
  { id: '03', title: 'Fund via Supported Method', note: 'Uniwire' },
  { id: '04', title: 'Funds Credited — Start Trading', note: null },
] as const

export function WebTestFunding() {
  const rootRef = useRef<HTMLElement>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const el = rootRef.current
    if (!el) return
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setVisible(true)
          io.disconnect()
        }
      },
      { threshold: 0.12 },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [])

  return (
    <section
      ref={rootRef}
      id="funding"
      className={`wf-section wf-section--compact${visible ? ' is-visible' : ''}`}
      aria-labelledby="wf-title"
    >
      <div className="wf-inner">
        <header className="wf-intro pp-enter" style={{ ['--pp-i' as string]: 0 }}>
          <p className="wf-eyebrow">Funding</p>
          <h2 id="wf-title" className="wf-title">
            Fund Your Live Trading Account
          </h2>
          <p className="wf-subtitle">
            Live accounts can be funded through the secure Client Portal. Demo accounts require no
            funding and receive a virtual opening balance.
          </p>
        </header>

        <ol className="wf-steps pp-enter" style={{ ['--pp-i' as string]: 1 }}>
          {STEPS.map((step) => (
            <li key={step.id} className="wf-steps__item pp-card-hover">
              <span className="wf-steps__num">{step.id}</span>
              <div>
                <strong>{step.title}</strong>
                {step.note ? <em>{step.note}</em> : null}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
